function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = getSymbolIterator();

export { getSymbolIterator, iterator };
//# sourceMappingURL=iterator.js.map
